import { initializeApp, apps } from 'firebase/app';
import 'firebase/auth';

import { CONFIG } from '../config/constant';
import { getAuth } from 'firebase/auth';

const app = initializeApp(CONFIG.firebaseContextConfig, 'app2');

export const auth = getAuth(app);
